<!-- Template -->

<template>
    <div class="contacts" v-if="selectedContacts.length > 0">
        <div class="title">
            <h3>Site contacts</h3>
        </div>
        <div v-if="selectedContacts.length > 0">
            <div v-for="contact in selectedContacts" :key="contact.id" class="mb-1">
                <v-popover
                    placement="right"
                    offset="5"
                    innerSelector="contact-info"
                    v-if="contact.firstName != '' && contact.lastName !=''"
                >
                    <a class="tooltip-target" :class="{me: contact.id == currentContactID}">
                        {{contact.firstName}}&nbsp;{{contact.lastName}}
                        <span class="icon-info"></span>
                    </a>
                    <template slot="popover">
                        <button type="button" v-close-popover aria-label="Close" class="close">
                            <span aria-hidden="true" class="icon-x"></span>
                        </button>
                        <div class="contact-info-popover">
                            <p class="tooltip-name">{{contact.firstName}}&nbsp;{{contact.lastName}}</p>
                            <p
                                class="tooltip-job-title"
                                v-if="contact.jobTitle"
                            >{{contact.jobTitle}}</p>
                            <p class="tooltip-email" v-if="contact.email">{{contact.email}}</p>
                            <p class="tooltip-phone" v-if="contact.phoneWork">
                                <span>Work:</span>
                                {{contact.phoneWork}}
                            </p>
                            <p class="tooltip-phone" v-if="contact.phoneMobile">
                                <span>Mobile:</span>
                                {{contact.phoneMobile}}
                            </p>
                            
                            <contact-sites :contactSites="contact.sites" :loggedInContact="currentContactID == contact.id"/>                            
                        </div>
                        <a
                            class="edit-button btn-large btn-blue"
                            v-close-popover
                            v-if="currentContactID == contact.id"
                            @click.prevent="$emit('select', contact)"
                        >
                            <span>Edit</span>
                        </a>
                    </template>
                </v-popover>
                <p v-if="contact.jobTitle">{{contact.jobTitle}}</p>
            </div>
        </div>
    </div>
</template>

<!-- Script -->

<script>
    import store from "@/store/store";
    import ContactSites from "@/components/Sidebar/ContactSites";
    export default {
        name: "Contacts",

        components:{
            ContactSites
        },

        props: ["contacts"],

        data() {
            return {
                selectedContacts: [],
                currentContactID: store.getters["session/get"].nameID
            };
        },

        watch: {
            $route() {
                this.update();
            }
        },

        created() {
            this.update();
        },

        methods: {
            update() {
                this.selectedContacts = this.$props.contacts;
            }
        }
    };
</script>

